'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Header = require('./components/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Body = require('./components/Body');

var _Body2 = _interopRequireDefault(_Body);

var _Footer = require('./components/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _ShowMore = require('./components/ShowMore');

var _ShowMore2 = _interopRequireDefault(_ShowMore);

var _addSortFns = require('./sorting/addSortFns');

var _addSortFns2 = _interopRequireDefault(_addSortFns);

var _sortData = require('./sorting/sortData');

var _sortData2 = _interopRequireDefault(_sortData);

var _addIds = require('./helpers/addIds');

var _addIds2 = _interopRequireDefault(_addIds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dataChange = function dataChange(data, columns, sortIdx, defaultSortIdx) {
  var changedData = (0, _addIds2.default)(data || []);
  return Number.isFinite(sortIdx) ? (0, _sortData2.default)(changedData, columns, sortIdx, defaultSortIdx) : changedData;
};

var RpTable = function (_PureComponent) {
  _inherits(RpTable, _PureComponent);

  function RpTable(props) {
    _classCallCheck(this, RpTable);

    var _this = _possibleConstructorReturn(this, (RpTable.__proto__ || Object.getPrototypeOf(RpTable)).call(this, props));

    _initialiseProps.call(_this);

    var defaultSortIdx = props.defaultSortIdx || props.initialSortIdx || 0;
    var sortIdx = props.initialSortIdx;
    var columns = (0, _addSortFns2.default)(props.columns, props.sortable, props.initialSortIdx);
    var data = dataChange(props.data, columns, sortIdx, defaultSortIdx);
    var itemsShown = props.resultsPerPage || data.length;

    _this.state = {
      columns: columns, defaultSortIdx: defaultSortIdx, data: data, sortIdx: sortIdx, itemsShown: itemsShown
    };
    return _this;
  }

  _createClass(RpTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props === nextProps) return;

      var newState = {};
      var _state = this.state,
          sortIdx = _state.sortIdx,
          defaultSortIdx = _state.defaultSortIdx,
          columns = _state.columns;

      var nextSortIdx = nextProps.initialSortIdx;

      if (this.props.columns !== nextProps.columns) {
        newState.columns = (0, _addSortFns2.default)(nextProps.columns, nextProps.sortable, sortIdx, defaultSortIdx);
      }

      if (this.props.data !== nextProps.data || this.props.columns !== nextProps.columns) {
        newState.data = dataChange(nextProps.data, newState.columns || columns, nextSortIdx, defaultSortIdx);
        newState.itemsShown = nextProps.resultsPerPage || newState.data.length;
      }

      this.setState(newState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          columns = _state2.columns,
          data = _state2.data,
          sortIdx = _state2.sortIdx,
          itemsShown = _state2.itemsShown,
          defaultSortIdx = _state2.defaultSortIdx;
      var _props = this.props,
          loading = _props.loading,
          noDataText = _props.noDataText,
          footerData = _props.footerData,
          setRowClass = _props.setRowClass,
          className = _props.className,
          uiType = _props.uiType,
          filter = _props.filter,
          headerRow = _props.headerRow,
          specialRow = _props.specialRow;


      var sortable = this.props.sortable && data.length > 1;

      var filteredData = filter ? data.filter(filter) : data;
      var specialFiltered = specialRow && sortIdx !== defaultSortIdx ? filteredData.filter(function (_ref) {
        var isSpecial = _ref.isSpecial;
        return !isSpecial;
      }) : filteredData;
      var shownData = itemsShown < specialFiltered.length ? specialFiltered.slice(0, itemsShown) : specialFiltered;

      var tableClassName = (0, _classnames2.default)('ui-table', className, 'ui-table_type' + uiType, sortable && 'ui-table_sortable');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { className: tableClassName },
          _react2.default.createElement(_Header2.default, {
            columns: columns,
            sortable: sortable,
            sortIdx: sortIdx,
            onHeaderCellClick: this.sortTable,
            headerRow: headerRow
          }),
          _react2.default.createElement(_Body2.default, {
            data: shownData,
            columns: columns,
            loading: loading,
            noDataText: noDataText,
            setRowClass: setRowClass,
            specialRow: specialRow
          }),
          !loading && footerData && _react2.default.createElement(_Footer2.default, {
            footerData: footerData,
            columns: columns
          })
        ),
        !loading && itemsShown < data.length && _react2.default.createElement(_ShowMore2.default, { onClick: this.showMore })
      );
    }
  }]);

  return RpTable;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.showMore = function () {
    _this2.setState({
      itemsShown: _this2.state.itemsShown + _this2.props.resultsPerPage
    });
  };

  this.sortTable = function (index) {
    var _state3 = _this2.state,
        data = _state3.data,
        columns = _state3.columns,
        defaultSortIdx = _state3.defaultSortIdx;
    var onSortUpdate = _this2.props.onSortUpdate;


    _this2.setState({
      data: (0, _sortData2.default)(data, columns, index, defaultSortIdx),
      sortIdx: index
    });

    if (onSortUpdate) {
      onSortUpdate(index);
    }
  };
};

RpTable.defaultProps = {
  data: [],
  uiType: 1,
  noDataText: 'No data for this table'
};

RpTable.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    cell: _propTypes2.default.func,
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    className: _propTypes2.default.string,
    sortFn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.oneOf(['numeric', 'numericReverse', 'alphabetic', 'byLastName'])])
  })).isRequired,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  sortable: _propTypes2.default.bool,
  initialSortIdx: _propTypes2.default.number,
  defaultSortIdx: _propTypes2.default.number,
  footerData: _propTypes2.default.shape({}),
  className: _propTypes2.default.string,
  uiType: _propTypes2.default.number,
  noDataText: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  resultsPerPage: _propTypes2.default.number,
  filter: _propTypes2.default.func,
  setRowClass: _propTypes2.default.func,
  specialRow: _propTypes2.default.func,
  headerRow: _propTypes2.default.func,
  onSortUpdate: _propTypes2.default.func
};

exports.default = RpTable;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/RpTable.js
// module id = 2278
// module chunks = 0